module.exports = __webpack_public_path__ + "assets/images/interweb.450d02996f58c3e74b4ccf1bf661cd4a.png";